import { useQuery } from '@apollo/client/react';
import { Paper, ButtonBase } from '@mui/material';
import {
  CompetitionRanking,
  CompetitionRankingRow,
  useItems,
} from '@scorenco/components';
import { RouteLink, Types } from '@scorenco/core';
import { useRouter } from 'next/router';

import { TeamRankingQueryDocument } from './Widget.query.generated';

type RankingTabProps = { team?: Types.Teams_Team_Detail };

export const RankingTab = ({ team }: RankingTabProps) => {
  const router = useRouter();

  const getRanking = useQuery(TeamRankingQueryDocument, {
    variables: {
      teamId: team?.id,
      cacheTTL: router.query.noCache ? 0 : undefined,
    },
    skip: !team?.id,
    context: {
      role: 'anonymous',
    },
  });

  const rankings = useItems(
    getRanking.data?.teams_team_detail_by_pk?.[0]?.team_in_season
      ?.last_competition_with_ranking?.[0]?.rankings,
    10
  );

  if (
    !getRanking.loading &&
    !getRanking.data?.teams_team_detail_by_pk?.[0]?.team_in_season
      ?.last_competition_with_ranking?.[0]?.rankings?.length
  ) {
    return (
      <Paper
        variant="bordered"
        sx={{
          overflow: 'hidden',
          p: 0,
          border: 'none',
          width: '100%',
          paddingTop: '2rem',
        }}
        className="no-ranking"
      >
        Le classement n'est pas encore disponible pour cette équipe pour le
        moment. Revenez plus tard.
      </Paper>
    );
  }

  return (
    <Paper
      variant="bordered"
      sx={{
        overflow: 'hidden',
        p: 0,
        border: 'none',
        width: '100%',
      }}
      className="paper-ranking"
    >
      <CompetitionRanking
        className="ranking"
        rankings={rankings?.filter(
          (r): r is NonNullable<typeof r> => r !== null
        )}
        highlightTeams={team?.id ? [team?.id] : undefined}
        style={{ width: '100%' }}
        sport={getRanking.data?.teams_team_detail_by_pk?.[0]?.club?.[0]?.sport}
        slots={{
          row: ({ ranking, ...rest }) => (
            <RouteLink
              href={`${process.env.NEXT_PUBLIC_WEB_URL}${ranking?.url}`}
            >
              <ButtonBase
                component="a"
                sx={{ display: 'block' }}
                className="button-row"
              >
                <CompetitionRankingRow
                  ranking={ranking}
                  {...rest}
                  className="ranking-row"
                />
              </ButtonBase>
            </RouteLink>
          ),
        }}
      />
    </Paper>
  );
};
